import React, { useState } from 'react';
import Loader from "react-loader-spinner";
import { MdClose } from 'react-icons/md';
import CONFIG from '../../config';
import { useEffect } from 'react';
import * as additionalPaymentsActions from '../../Redux/Actions/additionalPayments';

const AddModale = ({ t, showModale, loading, handleCancel, buttonLoading, handleOk, updateId }) => {

    const [name, setName] = useState('');
    const [electronicFee, setElectronicFee] = useState(CONFIG.electronicFee);
    const [vat, setVat] = useState(CONFIG.vat);
    const [serviceFee, setServiceFee] = useState(CONFIG.serviceFee);
    const [serviceFeeFlag, setServiceFeeFlag] = useState(false);  
    const [errMsg, setErrMsg] = useState('');
    const [updateData, setUpdateData] = useState('');
    const [description, setDescription] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [isTaxForCharges, setIsTaxForCharges] = useState(false);
    
    useEffect(() => {
        if(updateId) {
            getUpdateDetails();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateId]);

    const getUpdateDetails = () => {
        additionalPaymentsActions.getUpdate(updateId).then((res) => {
            if(res?.data) {
                setUpdateData(res.data);
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    
    useEffect(() => {
        if(updateData) {
            setName(updateData.name);
            setElectronicFee(updateData.electronicFeeInPercentage);
            setVat(updateData.vatAmountInPercentage);
            setServiceFee(updateData.serviceFee);
            setServiceFeeFlag(updateData.isServiceFee);
            setDescription(updateData?.description);
            setIsActive(updateData?.status === 'InActive' ? false: true);
            setIsTaxForCharges(updateData?.isTaxForCharges);
        }
    }, [updateData]);

    const submitHandler = () => {
        let sfFlag = serviceFeeFlag ? serviceFee !== '' : true;
        if(name && electronicFee && vat && sfFlag) {
            const payload = {
                name,
                status: isActive ? 'Active': 'InActive',
                electronicFeeInPercentage: electronicFee,
                vatAmountInPercentage: vat, 
                serviceFee: serviceFeeFlag ? serviceFee : '',
                isServiceFee: serviceFeeFlag,
                description,
                isTaxForCharges
            }
            
            if(updateId) {
                payload['id'] = updateId;
            } 
                
            handleOk(payload);
        } else {
            setErrMsg("Fill all the values!");
        }
        
    }

    const inputData = [
        { label: t("additionalPayments.name"), placeholder: t("additionalPayments.enterName"), setstate: setName, value: name, seterrmsg: setErrMsg },
        { label: t("additionalPayments.electronicFee"), placeholder: t("additionalPayments.enterElectronicFee"), setstate: setElectronicFee, value: electronicFee, seterrmsg: setErrMsg },
        { label: t("additionalPayments.vat"), placeholder: t("additionalPayments.enterVat"), setstate: setVat, value: vat, seterrmsg: setErrMsg }
    ];
    
    return(
        <div>
            <div className="modal" style={{display: (showModale ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{ updateId ? t("additionalPayments.update") : t("additionalPayments.title")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            { inputData.map(({ label, placeholder, setstate, value }, index) => (
                                 <div style={{ marginBottom: '15px'}} key={index}>
                                    <p className="text-primary mb-2">{label}</p>
                                    <input onChange={e => {setstate(e.target.value); setErrMsg('')}} value={value} className="form-control" placeholder={placeholder}/>
                                 </div>
                            ))
                            }
                            <div style={{ marginBottom: '15px'}}>
                                <p className="text-primary mb-2">{t("additionalPayments.serviceFee")}</p>
                                <div>
                                    <input type='checkbox' checked={serviceFeeFlag} onChange={() => setServiceFeeFlag(!serviceFeeFlag)}/>
                                    <label style={{ marginLeft: '5px'}}>Is service Fee applicable</label>
                                </div>
                                { serviceFeeFlag && <input onChange={e => {setServiceFee(e.target.value); setErrMsg('')}} value={serviceFee} className="form-control" placeholder={t("additionalPayments.enterServiceFee")}/>}
                                <div className='my-3'>
                                    <p className='text-primary mt-2'>{t("additionalPayments.status")}</p>
                                    <div class="form-check form-switch d-flex flex-column">
                                        <input class="form-check-input" type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
                                    </div>
                                </div>
                                <div className='my-2'>
                                    <input type='checkbox' checked={isTaxForCharges} style={{ width: '15px', height: '15px'}} onChange={(e) => setIsTaxForCharges(e.target.checked)}/>
                                    <label style={{ marginLeft: '5px'}}>Is tax applicable for Chargeable Amount</label>
                                </div>
                                <div>
                                    <p className="text-primary">{t("additionalPayments.description")}</p>
                                    <textarea value={description} onChange={e => setDescription(e.target.value)} className="w-100 p-2" rows="4" placeholder={t("additionalPayments.descriptionPlaceholder")}/>
                                </div>
                            </div>
                            { errMsg && <p style={{ color: 'red', textAlign: 'center'}}>{errMsg}</p>}
                        </div>
                        
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" disabled={loading || buttonLoading} onClick={handleCancel}>{t("additionalPayments.cancel")}</button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading || buttonLoading} onClick={submitHandler}>
                                {t("additionalPayments.submit")} {(loading || buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default AddModale;
